/** @jsx jsx */
import { cssMap, jsx } from '@atlaskit/css';
import { Drawer, DrawerCloseButton, DrawerContent, DrawerSidebar } from '@atlaskit/drawer/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
import {
	useTemplateLibraryState,
	useTemplateLibraryActions,
} from '@atlassian/proforma-template-library-store';
import { LazySuspense, lazy } from '@atlassian/react-loosely-lazy';
import { useUFOComponentExperience } from '@atlassian/ufo';
import { proformaTemplateLibraryExperience } from '../common/ui/experience/index.tsx';
import type { ProformaTemplateLibraryProps } from './main.tsx';

const styles = cssMap({
	drawerContent: {
		marginTop: token('space.0'),
	},
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyProformaTemplateLibrary = lazy(() =>
	import(/* webpackChunkName: "async-jira-proforma-template-library-main" */ './main').then(
		({ ProformaTemplateLibraryWithAnalytics }) => ProformaTemplateLibraryWithAnalytics,
	),
);

const LazyProformaTemplateLibraryWithUFO = (props: ProformaTemplateLibraryProps) => {
	useUFOComponentExperience(proformaTemplateLibraryExperience);
	return <LazyProformaTemplateLibrary {...props} />;
};

export const ProformaTemplateLibraryInDrawer = (props: ProformaTemplateLibraryProps) => {
	const { isTemplateLibraryOpen } = useTemplateLibraryState();
	const { setIsTemplateLibraryOpen } = useTemplateLibraryActions();

	return (
		<Drawer
			testId="proforma-template-library.ui.proforma-template-library-drawer"
			isOpen={isTemplateLibraryOpen}
			onClose={() => setIsTemplateLibraryOpen(false)}
			width="full"
		>
			<DrawerSidebar>
				<DrawerCloseButton />
			</DrawerSidebar>
			<DrawerContent xcss={styles.drawerContent}>
				<LazySuspense fallback={<Spinner size="large" />}>
					<LazyProformaTemplateLibraryWithUFO {...props} />
				</LazySuspense>
			</DrawerContent>
		</Drawer>
	);
};
